/* eslint-disable quotes */
/* eslint-disable quote-props */
const specialties = [
  "Acompanhamento Psicológico",
  "Acompanhamento Terapêutico",
  "Adolescência",
  "Adoção de Filhos",
  "Agorafobia",
  "Aleitamento Materno",
  "Anorexia Nervosa",
  "Ansiedade",
  "Análise Bioenergética",
  "Análise Transacional",
  "Análise do Comportamento | Behaviorismo",
  "Análise",
  "Aprendizagem",
  "Asperger",
  "Assessoramento acadêmico",
  "Atendimento Psicológico Domiciliar",
  "Autismo",
  "Autoestima",
  "Avaliação Neuropsicológica",
  "Avaliação Psicológica",
  "Baby Blues",
  "Borderline",
  "Bulimia Nervosa",
  "Casais",
  "Casamento",
  "Cirúrgia Bariátrica",
  "Ciúmes",
  "Cleptomania",
  "Coaching Executivo",
  "Coaching de Carreira",
  "Coaching de Emagrecimento",
  "Coaching de Negócios",
  "Coaching de Vida",
  "Coaching",
  "Compulsão Alimentar",
  "Compulsão por compras",
  "Compulsões",
  "Conflitos Amorosos",
  "Conflitos Familiares",
  "Conflitos Legais",
  "Constelações Sistêmicas Familiares",
  "Construcionismo Social",
  "Corporal | Reichiana",
  "Cuidados Paliativos",
  "Câncer",
  "Daseinsanalyse",
  "Dependência Jogos",
  "Dependência Química",
  "Depressão Pós-parto",
  "Depressão",
  "Desenvolvimento Pessoal",
  "Dificuldade de Aprendizagem",
  "Discalculia",
  "Disfunções Sexuais",
  "Dislexia",
  "Distimia",
  "Distúrbios Alimentares",
  "Doenças Crônicas",
  "Dor",
  "Drogas",
  "Educação Escolar",
  "Emagrecimento",
  "Encoprese",
  "Endividamento",
  "Entrevistas psicológicas",
  "Enurese",
  "Esquizofrenia",
  "Estresse pós-traumático",
  "Estresse",
  "Existencialismo Sartreano",
  "Família",
  "Fenomenologia Existencial",
  "Fobia Social",
  "Fobias",
  "Gestalt Terapia",
  "Hiperatividade",
  "Hipnoterapia",
  "Hipocondria",
  "Humanista | Abordagem centrada na pessoa",
  "Humanista",
  "Idosos Terceira Idade",
  "Infância",
  "Inteligência Emocional",
  "LGBT",
  "Libras - Língua Brasileira de Sinais",
  "Logoterapia",
  "Ludoterapia",
  "Ludoterapia",
  "Luto Perinatal",
  "Medos",
  "Menopausa",
  "Mindfulness",
  "Mindfulness",
  "Morte e Luto",
  "Neuropsicologia Infantil",
  "Neuropsicologia do Idoso",
  "Neuropsicologia",
  "Neuropsicologia",
  "Obesidade",
  "Orientação Profissional",
  "Orientação Psicológica",
  "Orientação Psicopedagógica",
  "Orientação Vocacional",
  "Orientação de Pais",
  "Orientação de educadores",
  "Orientação para Cirurgia Bariátrica",
  "Parar de fumar",
  "Pessoas com Deficiência - PCD",
  "Piromania",
  "Planejamento Psicopedagógico",
  "Preparação para Aposentadoria",
  "Problemas Financeiros",
  "Problemas de Aprendizagem",
  "Psicanálise",
  "Psicanálise | Bion",
  "Psicanálise | Freud",
  "Psicanálise | Klein",
  "Psicanálise | Lacan",
  "Psicanálise | Winnicott",
  "Psicodinâmica",
  "Psicodrama",
  "Psicologia Analítica | Jung",
  "Psicologia Clínica",
  "Psicologia Jurídica",
  "Psicologia Positiva",
  "Psicologia baseada em Sartre",
  "Psicologia do Esporte",
  "Psicologia infantil",
  "Psicopedagogia",
  "Psicossomática Psicanalítica",
  "Psicoterapia Breve",
  "Psicoterapia Existencialista",
  "Puerpério",
  "Reabilitação Cognitiva",
  "Reabilitação Neuropsicológica",
  "Relacionamentos afetivos",
  "Reprodução assistida",
  "Saúde Mental",
  "Saúde do trabalhador",
  "Sexualidade",
  "Suicídio",
  "Supervisão Clínica em Psicologia",
  "Síndrome de Burnout",
  "Síndrome do Pânico",
  "TDA e TDAH",
  "TOC - Transtorno Obsessivo ",
  "Tanatologia",
  "Teoria do Apego",
  "Terapia Breve Focada na Solução",
  "Terapia Cognitiva Comportamental Dialética",
  "Terapia Cognitivo Comportamental",
  "Terapia EMDR",
  "Terapia Familiar",
  "Terapia Narrativa",
  "Terapia Relacional Sistêmica",
  "Terapia Sexual",
  "Terapia do Esquema",
  "Transição de Carreiras",
  "Transpessoal",
  "Transtorno Bipolar",
  "Transtorno de Ansiedade Generalizada (TAG)",
  "Transtorno de Déficit de Atenção/Hiperatividade",
  "Transtorno de Estresse Pós Traumático (TEPT)",
  "Transtorno de Pânico ou Síndrome do Pânico",
  "Transtorno do Espectro Autista - TEA",
  "Transtorno do Sono",
  "Transtorno por Uso de Álcool",
  "Tratamento Memória",
  "Treinamento Empresarial",
  "Tricotilomania",
  "Violência Doméstica",
  "Violência Sexual",
  "Orientação Profissional",
  "Treinamento e Desenvolvimento de Pessoas",
  "Recrutamento e seleção",
  "Avaliação Psicológica",
  "Avaliação de Clima Organizacional",
  "Elaboração de projetos relacionados a Saúde Mental do Trabalhador",
  "Avaliação Neuropsicológica",
  "Neuromarketing",
  "Gestão por competências",
  "Assistência à saúde",
  "Clínica Psiquiátrica",
  "Comorbidade e Saúde Mental",
  "Dependência",
  "Diagnóstico e Classificação psicopatológicos",
  "Emergência",
  "Epidemiologia",
  "Espiritualidade",
  "Ética Forense",
  "Genética Humana",
  "Infância e Adolescência",
  "Saúde do Adulto",
  "Saúde do Idoso",
  "Medicina do Sono",
  "Medicina do Trabalho",
  "Neurociência",
  "Neuroimagem",
  "Neuromodulação",
  "Patologia Dual",
  "Política de Saúde",
  "Prevenção em Saúde Mental",
  "Psicofarmacologia",
  "Psicogeriatria",
  "Psicoimunologia",
  "Psicopatologia",
  "Psicoterapia",
  "Terapia",
  "Sexualidade",
  "Suicídio",
  "Psicologia hospitalar",
  "Neurologia Clínica",
  "Neurofeedback",
  "Terapia Virtual",
  "Terapia On-Oline",
  "Reabilitação",
  "Problemas de Aprendizagem Escolar"
]

export default specialties
